exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-contacto[data-v-4a36928d]{margin-top:60px;margin-bottom:60px}.card[data-v-4a36928d]{height:100%;border:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a36928d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing_Componentes/Contacto.vue
// module id = 1593
// module chunks = 0